import { render, staticRenderFns } from "./AssignmentUserList.vue?vue&type=template&id=6fc63f9e&scoped=true&"
import script from "./AssignmentUserList.vue?vue&type=script&lang=js&"
export * from "./AssignmentUserList.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentUserList.vue?vue&type=style&index=0&id=6fc63f9e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc63f9e",
  null
  
)

export default component.exports